export default __webpack_public_path__ + "static/media/w.582b8dde.svg";